import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { FormsModule } from '@angular/forms';
import { CardInfoEntregasComponent } from './card-info-entregas/card-info-entregas.component';

@Component({
    selector: 'app-dados-entregas',
    templateUrl: './dados-entregas.component.html',
    styleUrls: ['./dados-entregas.component.css'],
    standalone: true,
    imports: [FormsModule, CardInfoEntregasComponent]
})
export class DadosEntregasComponent{
  @Input() totalClientes: number = 0
  @Input() totalClientesAtendidos: number = 0
  @Input() totalClientesNaoAtendidos: number = 0
  @Input() totalClientesNaoVisitados: number = 0
  @Input() totalClientesAnalise: number = 0
  checked: boolean = false;
  
  @Output() filtroAlterado = new EventEmitter<void>();
  
  constructor(public dashboardService: DashboardService){
    this.setDataAtual();
  }

  ngOnInit(): void {
    const savedCheck = localStorage.getItem('toggleMovimentacaoDia');
    this.checked = savedCheck !== null ? JSON.parse(savedCheck) : false;
    this.dashboardService.toggleMovimentacaoDia = this.checked;
  }

  checkboxChange(value: boolean){
    this.checked = value;
    localStorage.setItem('toggleMovimentacaoDia', JSON.stringify(value));
    this.dashboardService.toggleMovimentacaoDia = value;
    this.filtroAlterado.emit();
  }

  setDataAtual() {
    const hoje = new Date();
    const ano = hoje.getFullYear();
    const mes = String(hoje.getMonth() + 1).padStart(2, '0'); 
    const dia = String(hoje.getDate()).padStart(2, '0');
    this.dashboardService.dataVisualizacao = `${ano}-${mes}-${dia}`;
  }

  dataChange() {
    this.filtroAlterado.emit(); 
  }
}


